export const SurveyEndMixin = {
  computed: {
    endType () {
      return this.survey?.end_type
    },
    endPageScript () {
      return this.survey?.end_page_script?.[this.endType?.includes('reward') ? 'reward' : this.endType]
    },
  },
  watch: {
    isFinished (value) {
      // Do not treat quota full as completed
      if (this.isQuotaFull) return;
			sessionStorage.clear();
      if (value && this.endType === 'completeurl') this.redirect()
    },
  }
}
